/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".map[_ngcontent-%COMP%]{height:98vh}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
